export default __webpack_public_path__ + "static/media/Eric_Chen_Resume.cc7492ec.pdf";